import React, { useEffect } from "react";
import { Clock, Search } from "lucide-react";
import { useAppDispatch } from "../../../redux/store";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useLocation } from "react-router-dom";
import { getGeoTrackingDetails } from "../../../redux/features/geoTracking";
import { useSelector } from "react-redux";
import {
  formatDateTime12hour,
} from "../../../utils/employeeTimeCardhelper";
const ViewTrackingMapPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { geoTrackingDetails } = useSelector(
    (state: any) => state?.geoTracking
  );
  const trackingData = location?.state?.tracking_data;
  const apiKey = process.env.GOOGLE_MAPS_API_KEY ?? "";
  const containerStyle = {
    width: "100%",
    height: "400px",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  };
  const center = {
    lat: Number(
      geoTrackingDetails?.data?.[0]?.document?.fields?.lat?.stringValue
    ),
    lng: Number(
      geoTrackingDetails?.data?.[0]?.document?.fields?.long?.stringValue
    ),
  };

  useEffect(() => {
    dispatch(
      getGeoTrackingDetails({
        tracking_uuid: location.state.tracking_uuid,
        employee_id: "", // optional - backend uses token if blank
      })
    );
  }, [dispatch, location.state.tracking_uuid]);

  return (
    <div className="max-w-full mx-4 border rounded-xl">
      <div className="flex items-center space-x-2 mb-2 px-4 pt-4">
        <Clock className="text-gray-600" />
        <div className="text-sm font-medium">Clock In</div>
        <div className="text-sm text-gray-600">
          {" "}
          {formatDateTime12hour(trackingData?.os_emp_start_datetime || "")}
        </div>
      </div>
      <hr className="my-3" />

      <div className="flex items-center space-x-2 mb-4 px-4">
        <Clock className="text-gray-600" />
        <div className="text-sm font-medium">Clock Out</div>
        <div className="text-sm text-gray-600">
          {" "}
          {formatDateTime12hour(trackingData?.os_emp_end_datetime || "")}
        </div>
      </div>
      <div className="flex items-center space-x-2 mb-4 px-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
          <input
            type="text"
            placeholder="Search"
            className="w-full pl-10 border rounded-md px-3 py-2"
          />
        </div>
      </div>

      <div className="px-4 pb-4 mt-32">
        <div className="w-full h-60 bg-gray-200 rounded-md flex items-center justify-center relative">
          {/* <span className="text-gray-500 text-sm"> */}{" "}
          <div
            style={{
              height: "450px",
              width: "100%",
              marginTop: "10px",
              borderRadius: "8px",
              overflow: "hidden",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          >
            {/* google maps integration */}
            <LoadScript googleMapsApiKey={apiKey}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={13}
              >
                {/* Example Marker */}
                <Marker position={center} />
              </GoogleMap>
            </LoadScript>
          </div>
          {/* </span> */}
        </div>
      </div>
    </div>
  );
};

export default ViewTrackingMapPage;
